import React from 'react';
import PropTypes from 'prop-types';
import {
	PieChart,
	Pie,
	Cell,
	Label
} from 'recharts';
import './DoughnutChart.scss';

let lastYOffset = 0;

const renderLabelContent = (props, allPoints, flagName) => {
	const {
		index,
		x,
		y,
		fill,
		midAngle,
		value,
		startAngle,
		endAngle,
		data
	} = props;

	const sliceName = data.name;
	const slice = startAngle - endAngle;
	const beforeDatapoint = allPoints[index - 1];

	const blXOffset = midAngle < 270 && midAngle >= 180 ? -12 : 0;
	const tlXOffset = midAngle < 180 && midAngle >= 90 ? -12 : 0;

	const trYOffset = midAngle < 90 && midAngle >= 0 ? -12 : 0;
	const tlYOffset = midAngle < 180 && midAngle >= 90 ? -12 : 0;

	const groupX = x + blXOffset + tlXOffset;
	let groupY = y + trYOffset + tlYOffset;

	if (slice < 6
		&& beforeDatapoint
		&& beforeDatapoint.value
		&& value
		&& (beforeDatapoint.value - value) < 1) {
		if ((groupY - lastYOffset) < 16) {
			groupY = lastYOffset + 14;
		}
	}
	lastYOffset = groupY;

	return (
		<g textAnchor="middle" transform={`translate(${groupX}, ${groupY})`}>
			<rect width="16" height="16" fill={fill} />
			<text width="16" fill="#ffffff" className="flag-text" aria-hidden>{index + 1}</text>
			<text className="sr-only">
				{' '}
				{`${flagName}  ${index + 1} Graphic ${sliceName}`}
			</text>
		</g>
	);
};

const DoughnutChart = props => {
	const {
		animate,
		width,
		height,
		slicePadding,
		innerRadius,
		outerRadius,
		centerLabel,
		data,
		chartTitle,
		flagName,
		includeLabel
	} = props;
	lastYOffset = 0;

	return (
		<div className="pie-chart-wrapper" aria-label={chartTitle}>
			<PieChart width={width} height={height}>
				<Pie
					data={data}
					dataKey="value"
					cx={width / 2}
					cy={height / 2}
					startAngle={360}
					endAngle={0}
					innerRadius={innerRadius}
					outerRadius={outerRadius}
					label={includeLabel ? item => { return renderLabelContent(item, data, flagName); } : null}
					paddingAngle={slicePadding}
					isAnimationActive={animate}>
					{
						data.map((item, index) => {
							const key = `slice-${index}-${item.name}`;
							return (
								<Cell key={key} fill={item.color} data={item} />
							);
						})
					}
					{
						centerLabel
							? (
								<Label width={50} position="center">
									{centerLabel}
								</Label>
							) : null
					}
				</Pie>
			</PieChart>
		</div>
	);
};

DoughnutChart.propTypes = {
	animate: PropTypes.bool,
	width: PropTypes.number,
	height: PropTypes.number,
	data: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		value: PropTypes.number.isRequired,
		color: PropTypes.string.isRequired
	})).isRequired,
	slicePadding: PropTypes.number,
	innerRadius: PropTypes.number,
	outerRadius: PropTypes.number,
	centerLabel: PropTypes.string,
	chartTitle: PropTypes.string,
	includeLabel: PropTypes.bool
};

DoughnutChart.defaultProps = {
	animate: true,
	width: 209,
	height: 194,
	slicePadding: 0.5,
	innerRadius: 43,
	outerRadius: 60,
	centerLabel: null,
	chartTitle: null,
	includeLabel: true
};

export default DoughnutChart;
